export default __webpack_public_path__ + "static/media/893.aef60219.png";